import { Outlet, RootRoute, Route, Router, createHashHistory } from '@tanstack/react-router';
import { MainLayout } from '@/components/MainLayout';
import { LoginPage } from '@/pages/Login';
import { RegisterPage } from '@/pages/Register';
import { ResetPasswordRequestPage } from '@/pages/ResetPasswordRequest';
import { ResetPasswordConfirmPage } from '@/pages/ResetPasswordConfirm';
import { DashboardPage } from '@/pages/Dashboard';
import { OffersPage } from '@/pages/Offers';
import { OfferDetailPage } from '@/pages/OfferDetail';
import { LinksPage } from '@/pages/Links';
import { ConversionsPage } from '@/pages/Conversions';
import { BalancePage } from '@/pages/Balance';
import { PayoutsPage } from '@/pages/Payouts';
import { ProfilePage } from '@/pages/Profile';

const rootRoute = new RootRoute({ component: () => <Outlet /> });

const loginRoute = new Route({ getParentRoute: () => rootRoute, path: '/login', component: LoginPage });
const registerRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/register',
  component: RegisterPage,
});
const resetRequestRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/reset-password',
  component: ResetPasswordRequestPage,
});
const resetConfirmRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/reset-password/confirm',
  component: ResetPasswordConfirmPage,
});

const appRoute = new Route({
  getParentRoute: () => rootRoute,
  id: 'app',
  component: MainLayout,
});

const indexRoute = new Route({ getParentRoute: () => appRoute, path: '/', component: DashboardPage });
const offersRoute = new Route({ getParentRoute: () => appRoute, path: '/offers', component: OffersPage });
const offerDetailRoute = new Route({
  getParentRoute: () => appRoute,
  path: '/offers/$slug',
  component: OfferDetailPage,
});
const linksRoute = new Route({ getParentRoute: () => appRoute, path: '/links', component: LinksPage });
const conversionsRoute = new Route({
  getParentRoute: () => appRoute,
  path: '/conversions',
  component: ConversionsPage,
});
const balanceRoute = new Route({ getParentRoute: () => appRoute, path: '/balance', component: BalancePage });
const payoutsRoute = new Route({ getParentRoute: () => appRoute, path: '/payouts', component: PayoutsPage });
const profileRoute = new Route({ getParentRoute: () => appRoute, path: '/profile', component: ProfilePage });

appRoute.addChildren([
  indexRoute,
  offersRoute,
  offerDetailRoute,
  linksRoute,
  conversionsRoute,
  balanceRoute,
  payoutsRoute,
  profileRoute,
]);

const routeTree = rootRoute.addChildren([
  loginRoute,
  registerRoute,
  resetRequestRoute,
  resetConfirmRoute,
  appRoute,
]);

export const router = new Router({
  routeTree,
  history: createHashHistory(),
  defaultPreload: 'intent',
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
